import { useState, useMemo, useEffect } from 'react'

export const upsellStorageName = 'upsells'
export const upsellViewedKey = 'upsell-viewed'

export const initialState = {
  canUpsell: false
}

export const useUpsellUIState = (upsells) => {
  const [{ canUpsell }, setState] = useState(initialState)

  useEffect(() => {
    const canUpsell = upsells.length > 0
    setState(prevState => ({ ...prevState, canUpsell }))
  }, [upsells])

  return useMemo(() => {
    const hideUpsell = () => (
      setState(prevState => ({
        ...prevState,
        canUpsell: false
      }))
    )

    const setUpsellCallbacks = (callbacks) => (
      setState(prevState => ({
        ...prevState,
        ...callbacks
      }))
    )

    return {
      canUpsell,
      hideUpsell,
      setUpsellCallbacks
    }
  }, [
    canUpsell
  ])
}
